import { parsePositiveNumber } from "./serviceOrderProducts";

export function fertilizationFromPlan(plan) {
  const raw = plan && plan.fertilization;
  if (!raw || typeof raw !== "object") return null;
  const fertilizerName = String(raw.fertilizer_name || "").trim();
  const fertilizerKgHa = parsePositiveNumber(raw.fertilizer_kg_ha);
  if (!fertilizerName && !fertilizerKgHa) return null;
  return {
    fertilizerName,
    fertilizerKgHa,
  };
}

export function buildFertilizationPayload({ fertilizerName, fertilizerKgHa }) {
  const name = String(fertilizerName || "").trim();
  const rate = parsePositiveNumber(fertilizerKgHa);
  if (!name && !rate) return null;
  return {
    fertilizer_name: name,
    fertilizer_kg_ha: rate,
  };
}

export function formatFertilizationLines(fertilization, translate) {
  if (!fertilization) return [];
  const t = typeof translate === "function" ? translate : (value) => value;
  const lines = [];
  if (fertilization.fertilizerName) {
    lines.push(`${t("Fertilizante")}: ${fertilization.fertilizerName}`);
  }
  if (fertilization.fertilizerKgHa > 0) {
    lines.push(
      `${t("Taxa-alvo")}: ${fertilization.fertilizerKgHa.toLocaleString("pt-BR", {
        maximumFractionDigits: 1,
      })} kg/ha`
    );
  }
  return lines;
}
